<!-- 
 01-01-2025
 Copyright (c) 2016 Aruba. All Rights Reserved.  
 -->
<div class="modal-header">
    <div class="modal-title h4" [innerHTML]="title"></div>
    <button aria-label="Close" data-dismiss="modal" class="close" type="button" (click)="closeModal()">
        <span aria-hidden="true">{{'main.charX' | translate}}</span>

    </button>
</div>

<div class="modal-body">
    <div class="row">
        <div *ngIf="message !== ''" class="font-16 {{extraResultClass}}" [innerHTML]="message">
            Extra text
        </div>
    </div>
</div>
<div class="modalDossier d-flex justify-content-left border-top-0 pt-0" >
    <a *ngIf="btnVisible" id="confirm" class="btn btn-primary px-5" href="{{appConfig.assistenzaDossier}}" 
    target="_self" [innerHTML]="btnText"></a>
    <button name="close" class="btn btn-link" (click)="closeModal()" [innerHTML]="btnClose"></button>
</div>
